import { useQuery } from '@tanstack/react-query';

import { queryClient } from '../components/queryClient';
import { MFA_METHOD } from '../enums';

export const useAllowed2FAMethods = () => {
    return useQuery({
        queryKey: ['allowed2FAMethods'],
        queryFn: () => Promise.resolve<MFA_METHOD | null>(null)
    });
};

export const useRequires2FA = () => {
    return useQuery({
        queryKey: ['requires2FA'],
        queryFn: () => Promise.resolve<boolean>(false)
    });
};

export const setAllowed2FAMethods = (methods: MFA_METHOD[]) => {
    queryClient.setQueryData(['allowed2FAMethods'], methods);
};

export const setRequires2FA = (value: boolean) => {
    queryClient.setQueryData(['requires2FA'], value);
};
